import React, { useEffect, useState } from 'react';
import { BsArrowUp } from 'react-icons/bs';
import cn from 'classnames';
import { Button, FCX } from "@datassential/platform-ui-lib";
import './ScrollToTop.scss';

const ScrollTopButton: FCX<{
    scrollElementId?: string;
}> = ({
    scrollElementId,
    testId,
}) => {
    const [isScrollButtonVisible, setIsScrollButtonVisible] = useState(false);

    useEffect(() => {
        const reactOnScroll = (scrollTop = 0) => {
            setIsScrollButtonVisible(scrollTop > 200);
        };

        const scrollElement = scrollElementId ? document.getElementById(scrollElementId) : document.scrollingElement;

        if (scrollElement) {
            const eventListener: EventListener = ({ target }) => {
                reactOnScroll((target as HTMLElement).scrollTop);
            };

            scrollElement.addEventListener('scroll', eventListener);

            return () => {
                scrollElement.removeEventListener('scroll', eventListener);
            }
        }
    }, []);

    const handleClick = () => {
        const scrollElement = scrollElementId ? document.getElementById(scrollElementId) : document.scrollingElement;
        scrollElement?.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (!isScrollButtonVisible) return null;

    return (
        <Button
            testId={testId}
            className={cn("ScrollToTop", "appears-top")}
            onClick={handleClick}
        >
            <BsArrowUp style={{ width: 20, height: 20 }}/>
        </Button>
    )
};

export default ScrollTopButton;